import Contact from "./components/Contact";
import CustomCursor from "./components/CustomCursor";
import Hero from "./components/Hero";
import Projects from "./components/Projects";
import TechStack from "./components/TechStack";
import ExperienceEducation from "./components/ExperienceEducation";
import ExtracurricularAchievements from "./components/ExtracurricularAchievements";

function App() {
  return (
    <>
      <CustomCursor />
      <Hero />
      <Projects />
      <TechStack />
      <ExperienceEducation />
      <ExtracurricularAchievements />
      <Contact />
    </>
  );
}

export default App;
